import React, { useState, useRef, useEffect } from "react";
import "reactflow/dist/style.css";
import "./Workflow Template Creation.css";
import WorkflowCanvas from "../../Common Components/Workflow_Canvas";
import CanvasHeader from "../../Common Components/Canvas_Header";
import CustomToaster, { notify } from "../../Common Components/Custom_Toaster";
import WorkflowTemplateServiceController from "../../../Controllers/WorkflowTemplateservice";
import LoadingOverlay from "../../Common Components/Loading_Overlay";
import SaveTemplate from "../../Common Components/SaveTemplate";
import EventConfirmPopup from "../../Common Components/Event_Confirm_Popup";
import CalloutNamePopup from "../../Common Components/Event_Callotname_Popup";

const CreateWorkflowTemplate = ({ onBackClick, handleSubflowCanvasClick, isSubflow, json, workflowName, level, workflowTempId, workflowReqBody, workflowTempName, isEditWorkflow, addFilters, createEvent, isCloneWorkflow }) => {
  const workflowTempCont = new WorkflowTemplateServiceController();
  const [workflowData, setWorkflowData] = useState(null);
  const [svgData, setSvgData] = useState(null);
  const workflowCanvasRef = useRef(null);
  const [client, setClient] = useState(json.dropdownData.client);
  const [dept, setDept] = useState(json.dropdownData.department);
  const [emptyDropdown, setEmptyDropdown] = useState(false);
  const [workflowTemplateName, setWorkflowTemplateName] = useState(workflowTempName ?? "");
  const [dropdownData, setDropdownData] = useState({});
  const [clientId, setClientId] = useState(json.dropdownData.client.id ?? "0");
  const [selectedValues, setSelectedValues] = useState({
    selectedClient: json.dropdownData?.client ?? {},
    selectedDept: json.dropdownData?.department ?? {},
  });
  const [isClientChanged, setIsClientChanged] = useState(false);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [note, setNote] = useState("");
  const [levelId, setlevelId] = useState(null);
  const [levelNames, setlevelNames] = useState(null);

  const templateIdRef = useRef(workflowTempId);
  const isEditWorkflowRef = useRef(isEditWorkflow);
  const isLevelDeletedRef = useRef(false);
  const isVersionConfirmationRef = useRef(false);

  const [workflowLevelComp, setWorkflowLevelComp] = useState([]);
  const isRoleChangedRef = useRef(false);
  const isCompletionRulesRef = useRef(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmPopupData, setConfirmPopupData] = useState({
    title: 'Confirm Permission Changes',
    popupType: 'Yes',
    name: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenCalloutNamePop, setIsOpenCalloutNamePop] = useState(false);
  const [calloutName, setCalloutName] = useState();
  const [selectedVersionId, setSelectedVersionId] = useState();
  const [selectedDefaultTempId, setSelectedDefaultTempId] = useState();
  const [defaultTempates, setDefaultTempates] = useState();

  const getSidebarLevelComponents = async () => {
    const body = await workflowTempCont.getSidebarComponents();
    setWorkflowLevelComp(
      Array.isArray(body) && body.length > 0 ?
        body.map((levelComp, index) => ({
          id: levelComp.id,
          calloutName: levelComp.levelCode,
          displayName: levelComp.levelName,
          mappedsubflowId: levelComp.mappedSubflowId,
        })
        )
        :
        []
    )
  }

  const handleSubmitNote = async () => {
    // TODO: API call or save logic here
    setNote(note);
    if (workflowTempId == "" || workflowTempId == "0") {
      notify(`Please save the template before saving add note.`, false);
      return false;
    }
    const response = await workflowTempCont.postAddWorkflowNote(workflowTempId, note);
    if (response && response.Success !== false) {
      setShowNoteModal(false);
      setNote("");
    }
  };

  const handleSelectChanges = (selectedValue, dropdownId) => {
    setSelectedValues((prevValues) => ({
      ...prevValues,
      [dropdownId]: selectedValue,
    }));
    if (dropdownId === "selectedClient") {
      setClientId(selectedValue.id);
      setIsClientChanged(true);
    } else {
      setIsClientChanged(false);
    }
    reloadCanvas();
  };

  const [templateJson, setTemplateJson] = useState(json);
  const [reloadCounter, setReloadCounter] = useState(0);

  useEffect(() => {
    setTemplateJson(json);

    if (workflowTempId != null && workflowReqBody?.versionId != null) {
      setSelectedVersionId(workflowReqBody.versionId);
      handleVersionChange(workflowReqBody.versionId);
    }
  }, [json]);

  const reloadCanvas = () => {
    setReloadCounter(prev => prev + 1);
  };

  const handleVersionChange = async (selectedValue) => {
    const body = await workflowTempCont.getVersionTemplateByTemplateId(workflowTempId, selectedValue);
    const localJson = body.templateData;
    setTemplateJson(localJson); // ✅ update state
    setSelectedVersionId(selectedValue);
    reloadCanvas();
  };

  const getDefaultTemplates = async () => {
    const body = await workflowTempCont.getDefaultTemplates();
    const formattedRoles = Array.isArray(body)
      ? body.map((role) => ({
        name: role.name,
        id: role.id
      }))
      : [];
    setDefaultTempates(formattedRoles);
  };

  const handleDefaultTempchange = async (selectedValue) => {
    if (selectedValue == "-- Select Default Template --") {
      setTemplateJson({
        nodes: [],
        edges: []
      });
      reloadCanvas();
    }
    else {
      const response = await workflowTempCont.getSelectedDefaultTemplateId(selectedValue);

      if (response && response.success !== false) {
        const localJson = response.templateData;
        setTemplateJson(localJson);       // ✅ update state
        setSelectedDefaultTempId(selectedValue); // ✅ store selected value      
        reloadCanvas();                  // ✅ refresh UI
      } else {
        console.log("Failed to fetch template");
      }
    }
  };

  const isSelectedClientEmpty = selectedValues.selectedClient.label === "--select--";
  const isSelectedDeptEmpty = selectedValues.selectedDept.label === "--select--";

  //Function called on clicking the save button in SaveTemplate popup
  //Function called using reference
  //Used for saving the json and converting the diagram into an SVG
  const handleOnSaves = () => {
    if (workflowCanvasRef.current) {
      const exportedData = workflowCanvasRef.current.exportToJson(); // Call the export function
      setWorkflowData(exportedData);
      if (exportedData) {
        // Now save the exported data
        // Perform your save operation here (e.g., send it to a server)
        setTimeout(() => {
          const svgImg = workflowCanvasRef.current.exportToSVG();
          setSvgData(svgImg);
        }, 500)

      } else {
        console.log("No data to save");
      }
      // }
    }
  };

  const seePreview = () => {
    console.log('preview shown');
  }

  const imgForPreview = () => {
    const svgImg = workflowCanvasRef.current.exportToSVG();
    setSvgData(svgImg);
  }

  function uint8ArrayToBase64(uint8Array) {
    let binary = '';
    const len = uint8Array.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(uint8Array[i]);
    }
    return window.btoa(binary);
  }

  const generalValidationsOnSave = () => {
    if (workflowCanvasRef.current) {
      const emptyCanvas = workflowCanvasRef.current.checkEmptyDiagram();
      const emptyNodes = workflowCanvasRef.current.checkEmptyNodes();
      if (isSelectedClientEmpty || isSelectedDeptEmpty) {
        notify(`Please select Client & Department dropdown values before saving`, false);
        return false;
      }
      else if (emptyCanvas) {
        notify(`There is no flow template to save.`, false);
        return false;
      }
      else if (emptyNodes) {
        notify(`There cannot be empty nodes in the diagram`, false);
        return false;
      }
      return true;
    }
  }

  const handleOnSave = async () => {
    if (!handlePageValidation()) {
      return;
    }
  debugger;
  
    const hasAnyPermission = allRolesData.some(role => role.isView);
    if (!hasAnyPermission && isEditWorkflow == false) {
      notify(
        "Please select at least one permission setting to save the template.",
        false
      );
      return;
    }

    if (isLevelDeletedRef.current) {
      setConfirmPopupData(prev => ({
        ...prev,
        title: "Confirm Deletion",
        popupType: "Yes",
        name: "This level will be deleted. Do you want to save your changes and continue, or cancel and go back to the list page?"
      }));
      setIsPopupOpen(true);
      return;
    }

    if (isRoleChangedRef.current) {
      setConfirmPopupData(prev => ({
        ...prev,
        title: "Unsaved Changes",
        popupType: "Ok",
        name: `You have unsaved permission changes for '${levelNames}'. Do you want to save before continuing?`
      }));
      setIsPopupOpen(true);
      return;
    }

    const flowData = workflowCanvasRef.current.exportToJson();
    const parsedData = JSON.parse(flowData);
    const nodes = parsedData.nodes || [];

    // Get all levels from nodes
    const levelsInFlow = nodes
      .map(node => node?.data?.level)
      .filter(level => level); // remove undefined/null

    // Check if L0 and L7 exist
    const hasL0 = levelsInFlow.includes("L0");
    const hasL7 = levelsInFlow.includes("L7");

    if (!hasL0 || !hasL7) {
      let missingLevels = [];
      if (!hasL0) missingLevels.push("L0");
      if (!hasL7) missingLevels.push("L7");

      notify(`Mandatory level(s) missing: ${missingLevels.join(", ")}. Please add them before saving.`, false);

      return; // ⛔ stop execution
    }

    if (isEditWorkflow == false)
      setIsOpenCalloutNamePop(true);
    else if (isEditWorkflow == true)
      ConfirmUpdateForVersion();
    else
      handleSaveInputCalloutName();
  };

  const ConfirmUpdateForVersion = async () => {
    setConfirmPopupData(prev => ({
      ...prev,
      title: "Version",
      popupType: "Yes",
      name: `Are you sure you want to increase the version? Or would you like to discard the changes?`
    }));
    setIsPopupOpen(true);
    isVersionConfirmationRef.current = true;
  }

  const handleSaveInputCalloutName = async () => {
    const exportedData = workflowCanvasRef.current.exportToJson(); // Call the export function
    setWorkflowData(exportedData);
    if (exportedData) {
      // Now save the exported data
      const svgImg = await workflowCanvasRef.current.exportToSVG();
      const base64String = svgImg ? uint8ArrayToBase64(svgImg) : "";

      let exportedJsonData = exportedData;
      if (typeof exportedData === "string") {
        exportedJsonData = JSON.parse(exportedData);
      }

      const getJsonData = async () => {
        document.getElementById('loadingOverlay').style.display = 'flex';
        const jsonData = {
          id: workflowTempId && workflowTempId !== 0 ? workflowTempId : templateIdRef.current ?? 0,
          client: selectedValues.selectedClient,
          department: selectedValues.selectedDept,
          templateName: "",
          templateType: "",
          templateData: exportedJsonData,
          consolidatedTemplate: null,
          calloutName: calloutName ?? "",
          createOrModifiedBy: workflowReqBody.createOrModifiedBy ?? '',
          date: workflowReqBody.date ?? '',
          isActive: workflowReqBody.isActive ?? false,
          isPublished: workflowReqBody.isPublished ?? false,
          createdBy: workflowReqBody.createdBy ?? 0,
          createdDate: workflowReqBody.createdDate ?? null,
          modifiedDate: workflowReqBody.modifiedDate ?? null,
          modifiedBy: workflowReqBody.modifiedBy ?? null,
          action: json ? JSON.stringify(json) === exportedData ? null : "U" : null,
          previewFileName: null,
          diagram: base64String,
          notes: note,
          mode: isCloneWorkflow ? "isClone" : (isEditWorkflow || isEditWorkflowRef.current) ? "isEdit" : "",
        };

        try {
          const body = await workflowTempCont.addEditWorkflowTemplate(jsonData);
          document.getElementById('loadingOverlay').style.display = 'none';

          // Normalize response to avoid casing issues
          const success = body?.isSuccess ?? body?.isSuccess ?? false;
          const message = (body?.Response ?? body?.response ?? body?.message ?? body?.message ?? "").replace(/^Message:/i, "").trim();
          const tempWorkflowName = body?.templateName || workflowTemplateName;
          if (success) {
            setWorkflowTemplateName(tempWorkflowName); // 👈 better than message
            if (message.toLowerCase().includes("only one clone")) {
              notify(message ? `${tempWorkflowName} or Please modify to clone.` : "Please modify to clone.", false);
            } else {
              notify(`${tempWorkflowName} has been successfully ${isCloneWorkflow ? "Cloned" : isCloneWorkflow ? "updated" : "Saved"}`, true);
              if (isCloneWorkflow == true || isEditWorkflow == true || isEditWorkflowRef.current == true) {
                setTimeout(async () => {
                  onBackClick(); // Redirecting to Workflow Template List Page.
                }, 2500);
              }
              else if (isCloneWorkflow == false && isEditWorkflow == false) {
                // This function will inserting first time.
                templateIdRef.current = body?.id;
                isEditWorkflowRef.current = true;
                workflowTempId = body?.id;
                await onSaveRoleAccessAfterWorkflowTemplate(); // Calling to save permission settings.              
              }
            }
          } else {
            notify(message || "There was an error while saving the workflow template.", false);
          }
        } catch (exp) {
          notify(
            "There was an error while performing deletion operation. Please try again later...",
            false
          );
        }
      }
      getJsonData();
    }
  }

  const handleNoteClick = (event) => {
    setShowNoteModal(true);
  }

  const handleApplyFilters = () => {
    if (filterRef.current) {
      const additionalFilterDataByJson = filterRef.current.createFilterDataJson();
    }
    else {
      console.log('checked current ref', filterRef.current);
    }
  }

  const [allRolesData, setAllRolesData] = useState([]);
  const [allCompletionRuleData, setAllCompletionRuleData] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState({});

  const getAllRoles = async () => {
    const body = await workflowTempCont.getAllRoles();

    const formattedRoles = Array.isArray(body)
      ? body.map((role) => ({
        role_Mstr_Name: role.role_Mstr_Name,
        id: role.role_Mstr_Code,
        status: true,
      }))
      : [];
    setAllRolesData(formattedRoles);
  };

  const handlePermissionChange = (roleId, permissionKey) => {
    isRoleChangedRef.current = true;

    setAllRolesData(prev =>
      prev.map(role =>
        role.id === roleId
          ? { ...role, [permissionKey]: !role[permissionKey] }
          : role
      )
    );
  };

  const handleResetAll = () => {
    isRoleChangedRef.current = false;
    setAllRolesData(prev =>
      prev.map(role => ({
        ...role,
        isView: false
      }))
    );
  };

  const onSaveRoleAccess = async () => {
    // If there is no template id saving template id
    if (!templateIdRef.current || templateIdRef.current === 0) {
      isRoleChangedRef.current = true;
      await handlePermissionTabToSaveWorkflowTemplate();
    }
    else {
      await onSaveRoleAccessAfterWorkflowTemplate(); // Calling to save permission settings. 
    }
  };

  const onSaveRoleAccessAfterWorkflowTemplate = async () => {
    const loclevelId = levelId; // current node levelId
    const workflowTemplateId = workflowTempId !== 0 ? workflowTempId : templateIdRef.current ?? 0;
    const workflowType = "WF";
    const workFlowPermissionStatus = allRolesData
      .filter(role => role.isView || role.isAdd || role.isEdit || role.isExecute)
      .map(role => ({
        id: 0,
        workFlowPermissionId: 1,
        roleId: role.id,
        isView: !!role.isView,
        isAdd: !!role.isAdd,
        isEdit: !!role.isEdit,
        isExecute: !!role.isExecute
      }));

    const workFlowPermissionDto = {
      id: 0,                        // workflow permission id; set dynamically if needed
      workflowType: workflowType,
      templateId: workflowTemplateId,
      levelEventId: loclevelId,
      workFlowPermissionStatus: workFlowPermissionStatus
    };

    const body = await workflowTempCont.postAddUpdateWorkFlowPermission(workFlowPermissionDto);
    await notify(`${levelNames} ${body}`, true);
    setSelectedRoles({});
    isRoleChangedRef.current = false;
  };

  const openPopupEvent = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const handleCancel = async () => {
    setIsLoading(false);
    isRoleChangedRef.current = false;
    setIsPopupOpen(false);
    handleResetAll();
    if (isLevelDeletedRef.current) {
      isLevelDeletedRef.current = false;
      onBackClick();
    }
    if (isVersionConfirmationRef.current) {
      isVersionConfirmationRef.current = false;
      onBackClick();
    }
  };

  const handleVersionConfirm = async () => {
    setIsLoading(true);
    setIsPopupOpen(false);
    if (isLevelDeletedRef.current) {
      isLevelDeletedRef.current = false;
      await handleOnSave();
    }
    else if (isVersionConfirmationRef.current) {
      isVersionConfirmationRef.current = false;
      setIsOpenCalloutNamePop(true);
      //await handleSaveInputCalloutName();
    }
    else
      await onSaveRoleAccess();
  };

  const handleNodeDeleted = async () => {
    isLevelDeletedRef.current = true;
  }

  const handleNodeSelection = async (node) => {
    try {
      if (isRoleChangedRef.current) {
        setIsPopupOpen(true);
        return;
      }
      document.getElementById('loadingOverlay').style.display = 'flex';
      const levelName = node?.data?.level;
      const levelId = node?.data?.levelId;
      const workflowTemplateId = workflowTempId !== 0 ? workflowTempId : templateIdRef.current ?? 0;
      const workflowType = "WF";
      setlevelId(levelId);
      setlevelNames(levelName);
      // 1️⃣ Fetch data
      const bodyallWorkFlowPermission = await workflowTempCont.getWorkFlowPermissionById(workflowTemplateId, workflowType, levelId); // array of permissions
      const bodyallRolesData = await workflowTempCont.getAllRoles(); // array of roles
      const formattedRoles = Array.isArray(bodyallRolesData)
        ? bodyallRolesData.map((role) => ({
          role_Mstr_Name: role.role_Mstr_Name,
          id: role.role_Mstr_Code
        }))
        : [];
      // Flatten all workFlowPermissionStatus from body2
      const permissionIds = bodyallWorkFlowPermission.map(item => item.roleId);
      const permissionIdSet = new Set(permissionIds);
      // 3️⃣ Map all roles
      const updatedRoles = formattedRoles.map(role => ({
        ...role,
        isView: permissionIdSet.has(role.id)
      }));
      // 4️⃣ Update state
      setAllRolesData(updatedRoles);
      getAllCompletionRule(workflowTemplateId, levelId);
      document.getElementById('loadingOverlay').style.display = 'none';

    } catch (error) {
      console.error("Error fetching workflow permissions:", error);
    }
  };

  const getAllCompletionRule = async (workflowTemplateId, levelId) => {
    const flowData = workflowCanvasRef.current.exportToJson(); // Call the export function
    const parsedData = JSON.parse(flowData);
    const levels = parsedData.nodes.map(node => ({
      id: node.id,
      calloutName: node.data.level,
      displayName: node.data.level,
      mappedsubflowId: node.data.levelId
    })).sort((a, b) => {
      const numA = parseInt(a.displayName.replace(/^L/, ""), 10);
      const numB = parseInt(b.displayName.replace(/^L/, ""), 10);
      return numA - numB;
    });

    setWorkflowLevelComp(levels);
    const response = await workflowTempCont.getCompletionRulesByWorkflowId(workflowTemplateId, levelId); // array of permissions
    setAllCompletionRuleData(response);
  }

  const filterRef = useRef(null);
  useEffect(() => {
    if (isSelectedClientEmpty || isSelectedDeptEmpty) {
      setEmptyDropdown(true);
    } else {
      setEmptyDropdown(false);
      setDropdownData({
        "client": selectedValues.selectedClient,
        "department": selectedValues.selectedDept,
        "workflowName": { label: "--select--", value: "--select--", dropdownId: "0" },
        "level": { label: "--select--", value: "--select--", dropdownId: "0" }
      });
    }
  }, [selectedValues]);

  useEffect(() => {
  }, [confirmPopupData]);

  useEffect(() => {
    if (levelNames) {
      setConfirmPopupData(prev => ({
        ...prev,
        name: `Please save the role permission changes for '${levelNames}' before proceeding or cancel the changes,`
      }));
    }
  }, [levelNames]);

  useEffect(() => {
    const initialSelected = {};
    allRolesData.forEach(role => {
      initialSelected[role.id] = role.status ?? false;
    });
    setSelectedRoles(initialSelected);
  }, [allRolesData]);

  useEffect(() => {
    getDefaultTemplates();
  }, [workflowTempId]);

  useEffect(() => {
    if (workflowTempId) {
      // safe to use updated templateId here
      console.log("Updated workflowTempId:", workflowTempId);
    }
  }, [workflowTempId]);

  useEffect(() => {
    //getSidebarLevelComponents();
  }, []); // ✅ empty array means run once

  //Checking workflow canvas reference on re-rendering
  useEffect(() => {
    if (workflowCanvasRef.current) {
    }
  }, []);

  const onSaveConstraints = async ({ completionRules, node, onUpdateNode }) => {
    if (!completionRules.ruleName.trim()) {
      await notify("Please enter a rule name.", false);
      return;
    }
    if (!templateIdRef.current || templateIdRef.current === 0) {
      isCompletionRulesRef.current = true;
      await handleAdvanceTabToSaveWorkflowTemplate(completionRules, node, onUpdateNode);
    }
    else {
      await onSaveConstraintsAfterWorkflowTemplate(completionRules, node, onUpdateNode);
    }
  };

  const onSaveConstraintsAfterWorkflowTemplate = async (completionRules, node, onUpdateNode) => {
    const requestDto = {
      WorkflowTemplateId: workflowTempId && workflowTempId !== 0 ? workflowTempId : templateIdRef.current ?? 0,
      LevelId: levelId,
      Rules: completionRules.conditions
        .filter(c => c.dependsOn)
        .map(cond => ({
          LogicalOperator: cond.condition,
          DependentLevel: cond.dependsOn,
        })),
    };
    if (onUpdateNode && node) {
      onUpdateNode({
        ...node.data,
        completionRules
      });
    }

    const body = await workflowTempCont.postAddUpdateWFCompletionRule(requestDto);
    const success = body?.isSuccess ?? body?.isSuccess ?? false;
    const message = (body?.Response ?? body?.response ?? body?.message ?? body?.message ?? "").replace(/^Message:/i, "").trim();

    if (success) {
      await notify(`${levelNames} ${message}`, true);
    }
    else {
      await notify(`${levelNames} ${message}`, false);
    }
    isCompletionRulesRef.current = false;
  }

  const handleAdvanceTabToSaveWorkflowTemplate = async (completionRules, node, onUpdateNode) => {
    if (!handlePageValidation()) {
      return;
    }

    const exportedData = workflowCanvasRef.current.exportToJson(); // Call the export function
    setWorkflowData(exportedData);
    if (exportedData) {
      // Now save the exported data
      const svgImg = await workflowCanvasRef.current.exportToSVG();
      const base64String = svgImg ? uint8ArrayToBase64(svgImg) : "";

      let exportedJsonData = exportedData;
      if (typeof exportedData === "string") {
        exportedJsonData = JSON.parse(exportedData);
      }
      const getJsonData = async () => {
        document.getElementById('loadingOverlay').style.display = 'flex';
        const jsonData = {
          id: workflowTempId && workflowTempId !== 0 ? workflowTempId : templateIdRef.current ?? 0,
          client: selectedValues.selectedClient,
          department: selectedValues.selectedDept,
          templateName: "",
          templateType: "",
          templateData: exportedJsonData,
          consolidatedTemplate: null,
          calloutName: calloutName ?? "",
          createOrModifiedBy: workflowReqBody.createOrModifiedBy ?? '',
          date: workflowReqBody.date ?? '',
          isActive: workflowReqBody.isActive ?? false,
          isPublished: workflowReqBody.isPublished ?? false,
          createdBy: workflowReqBody.createdBy ?? 0,
          createdDate: workflowReqBody.createdDate ?? null,
          modifiedDate: workflowReqBody.modifiedDate ?? null,
          modifiedBy: workflowReqBody.modifiedBy ?? null,
          action: json ? JSON.stringify(json) === exportedData ? null : "U" : null,
          previewFileName: null,
          diagram: base64String,
          notes: note,
          mode: isCloneWorkflow ? "isClone" : (isEditWorkflow || isEditWorkflowRef.current) ? "isEdit" : "",
        };

        try {
          const body = await workflowTempCont.addEditWorkflowTemplate(jsonData);
          document.getElementById('loadingOverlay').style.display = 'none';

          // Normalize response to avoid casing issues
          const success = body?.isSuccess ?? body?.isSuccess ?? false;
          const message = (body?.Response ?? body?.response ?? body?.message ?? body?.message ?? "").replace(/^Message:/i, "").trim();
          if (success) {
            // This function will inserting first time.
            templateIdRef.current = body?.id;
            isEditWorkflowRef.current = true;
            workflowTempId = body?.id;
            setWorkflowTemplateName(body?.templateName); // 👈 better than message
            if (isCompletionRulesRef.current)
              await onSaveConstraintsAfterWorkflowTemplate(completionRules, node, onUpdateNode);

          } else {
            notify(message || "There was an error while saving the workflow template.", false);
          }
        } catch (exp) {
          notify(
            "There was an error while performing deletion operation. Please try again later...",
            false
          );
        }
      }
      getJsonData();
    }
  };

  const handlePermissionTabToSaveWorkflowTemplate = async () => {
    if (!handlePageValidation()) {
      return;
    }

    const exportedData = workflowCanvasRef.current.exportToJson(); // Call the export function
    setWorkflowData(exportedData);

    if (exportedData) {
      // Now save the exported data
      const svgImg = await workflowCanvasRef.current.exportToSVG();
      const base64String = svgImg ? uint8ArrayToBase64(svgImg) : "";

      let exportedJsonData = exportedData;
      if (typeof exportedData === "string") {
        exportedJsonData = JSON.parse(exportedData);
      }

      const getJsonData = async () => {
        document.getElementById('loadingOverlay').style.display = 'flex';
        const jsonData = {
          id: workflowTempId && workflowTempId !== 0 ? workflowTempId : templateIdRef.current ?? 0,
          client: selectedValues.selectedClient,
          department: selectedValues.selectedDept,
          templateName: "string",
          templateType: "",
          templateData: exportedJsonData,
          consolidatedTemplate: null,
          calloutName: calloutName ?? "",
          createOrModifiedBy: workflowReqBody.createOrModifiedBy ?? '',
          date: workflowReqBody.date ?? '',
          isActive: workflowReqBody.isActive ?? false,
          isPublished: workflowReqBody.isPublished ?? false,
          createdBy: workflowReqBody.createdBy ?? 0,
          createdDate: workflowReqBody.createdDate ?? null,
          modifiedDate: workflowReqBody.modifiedDate ?? null,
          modifiedBy: workflowReqBody.modifiedBy ?? null,
          action: json ? JSON.stringify(json) === exportedData ? null : "U" : null,
          previewFileName: null,
          diagram: base64String,
          notes: note,
          mode: isCloneWorkflow ? "isClone" : (isEditWorkflow || isEditWorkflowRef.current) ? "isEdit" : "",
        };

        try {
          const body = await workflowTempCont.addEditWorkflowTemplate(jsonData);
          document.getElementById('loadingOverlay').style.display = 'none';

          // Normalize response to avoid casing issues
          const success = body?.isSuccess ?? body?.isSuccess ?? false;
          const message = (body?.Response ?? body?.response ?? body?.message ?? body?.message ?? "").replace(/^Message:/i, "").trim();
          if (success) {
            // This function will inserting first time.
            templateIdRef.current = body?.id;
            isEditWorkflowRef.current = true;
            workflowTempId = body?.id;
            setWorkflowTemplateName(body?.templateName); // 👈 better than message
            if (isRoleChangedRef.current)
              await onSaveRoleAccessAfterWorkflowTemplate();

          } else {
            notify(message || "There was an error while saving the workflow template.", false);
          }
        } catch (exp) {
          notify(
            "There was an error while performing deletion operation. Please try again later...",
            false
          );
        }
      }
      getJsonData();
    }
  };

  const handlePageValidation = () => {
    if (isSelectedClientEmpty) {
      notify("Select Client for Workflow.", false);
      return false;
    }
    if (isSelectedDeptEmpty) {
      notify("Select Department for Workflow.", false);
      return false;
    }
    return true;
  };

  const handleInputChange = (event) => {
    setCalloutName(event.target.value);
  };

  const onClose = () => {
    setIsOpenCalloutNamePop(false);
  };

  return (
    <>
      <CanvasHeader
        selectedValues={selectedValues}
        handleSelectChange={handleSelectChanges}
        handleVersionChange={handleVersionChange}
        clientId={clientId}
        backClick={onBackClick}
        saveJson={handleOnSave}
        backButtonLabel={`Workflow Template List ${workflowTemplateName ? ` | Edit Workflow Template : ${workflowTemplateName}` : ''}`}
        client={client}
        department={dept}
        savedName={'workflowTemplateName'}
        isEdit={isEditWorkflow}
        isClone={isCloneWorkflow}
        event={false}
        fromSubflow={false}
        seePreview={seePreview}
        imgForPreview={imgForPreview}
        isClientChanged={isClientChanged}
        handleInputCalloutName={"handleInputCalloutName"}
        isTransaction={false}
        isSubflow={false}
        handleSaveFilters={handleApplyFilters}
        addFilters={[]}   // ✅ SAFE
        workflowTemplateId={workflowTempId}
        saveValidations={generalValidationsOnSave}
        isSaveDialogOpen={null}
        closeDialog={null}
        handleNoteClick={handleNoteClick}
        selectedVersionId={selectedVersionId}
        handleDefaultTempchange={handleDefaultTempchange}
        defaultTemplateView={defaultTempates}
      />

      <WorkflowCanvas
        //key={`${dropdownData.workflowName}-${reloadCounter}`} // 🔹 unique key forces remount
        key={`${reloadCounter}`} // 🔹 unique key forces remount
        ref={workflowCanvasRef}
        workflow={true}
        emptyDropdown={emptyDropdown}
        handleSubflowCanvasClick={handleSubflowCanvasClick}
        isSubflow={isSubflow}
        dropdownData={dropdownData}
        json={templateJson}
        isTransaction={false}
        createEvent={createEvent}
        dropdownEventData={workflowLevelComp}
        allRolesData={allRolesData}
        onSaveRoleAccess={onSaveRoleAccess}
        handlePermissionChange={handlePermissionChange}
        onParentNodeClick={handleNodeSelection}
        onParentNodeDeleted={handleNodeDeleted}
        workflowTempId={workflowTempId}
        onSaveConstraints={onSaveConstraints}
        allCompletionRule={allCompletionRuleData}
      />

      <CustomToaster />
      <LoadingOverlay />

      {showNoteModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Add Note</h3>
           

            <textarea
              className="note-input"
              placeholder="Enter Note"
              value={note}
              maxLength={1000}
              onChange={(e) => setNote(e.target.value)}
            />
            {note.length >= 1000 &&
              <p style={{ color: 'red', textAlign: "start", marginBottom: "5px" }}>Input Char Limit Reached</p>
            }

            <p className="modal-subtitle">
              <b>Note</b> : Added notes are displayed on the Workflow Grid screen (maximum 1000 characters). Notes are saved for the template, not the version.
            </p>

            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowNoteModal(false)}
              >
                Cancel
              </button>
              <button
                className="submitNote-btn"
                onClick={handleSubmitNote}
                disabled={!note.trim()}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      <CalloutNamePopup
        open={isOpenCalloutNamePop}
        onClose={onClose}
        onSave={handleSaveInputCalloutName}
        handleInputChange={handleInputChange}
      />
      <EventConfirmPopup
        openConfirmationPopup={isPopupOpen}
        onClose={openPopupEvent}
        handleCancel={handleCancel}
        handleSave={handleVersionConfirm}
        isLoading={isLoading}
        popupData={confirmPopupData}
      />
    </>
  );
};

export default CreateWorkflowTemplate;
